var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tab-sync" }, [
      _vm._v(_vm._s(_vm.$t("language.popup.selectSync")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tab-sync-box" }, [
      _vm.realTimeShow
        ? _c(
            "div",
            { staticClass: "page-one" },
            [
              _c("selects", {
                ref: "selectrealTime",
                staticStyle: { margin: "0px !important", float: "left" },
                attrs: {
                  widthVal: 260,
                  selectOption: _vm.realTimeSelectOption,
                  placeholder: _vm.realTimeSelectValue
                },
                on: {
                  changeOption: _vm.onChangeOptionRealTime,
                  deleteSelectOption: _vm.deleteSelectOptionRealTime
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.realTimeShow ? "page-two" : "page-one"] },
        [
          _c("selects", {
            ref: "selectOne",
            staticStyle: { margin: "0px !important", float: "left" },
            attrs: {
              widthVal: 260,
              selectOption: _vm.selectOption,
              placeholder: _vm.selectValue
            },
            on: {
              changeOption: _vm.onChangeOptionOne,
              deleteSelectOption: _vm.deleteSelectOptionOne
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class:
            _vm.realTimeShow && _vm.pageLanguage.includes(_vm.$i18n.locale)
              ? "page-bottom"
              : "page-two"
        },
        [
          _c("selects", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectTwoShow,
                expression: "selectTwoShow"
              }
            ],
            ref: "selectTwo",
            staticStyle: { margin: "0px !important", float: "right" },
            attrs: {
              widthVal: 260,
              selectOption: _vm.selectOptionTwo,
              placeholder: _vm.selectValueTwo
            },
            on: {
              changeOption: _vm.onChangeOptionTwo,
              deleteSelectOption: _vm.deleteSelectOptionTwo
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "des-tip" }, [
      _vm._v(
        "\r\n        " +
          _vm._s(_vm.$t("language.popup.tipsFor")) +
          " " +
          _vm._s(_vm.tipsTitle) +
          ":\r\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "des-tip-content" }, [
      _vm._v("\r\n        " + _vm._s(_vm.tipsDesc) + "\r\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer-tip" }, [
      _c("div", {
        staticClass: "icon-util  tip-check",
        class: [_vm.isActive == false ? "nocheck-small-blue" : "check-small"],
        on: {
          click: function($event) {
            return _vm.tipCheck()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "check-item-position",
          staticStyle: { "margin-right": "5Px" },
          on: {
            click: function($event) {
              return _vm.tipCheck()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("language.popup.automaRename")))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "icon-util question-mark question-position" }, [
        _c(
          "div",
          {
            class: _vm.$i18n.locale == "france" ? "prompt-right" : "prompt-tip"
          },
          [_vm._v(_vm._s(_vm.$t("language.popup.optionsPrompt")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d2bcb46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2bcb46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_transfer_options/tab_sync.vue
// module id = null
// module chunks = 